var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPageScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 200,
    viewBox: "0 0 195 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9278 16.0742H25.0601V22.3242H32.9278V16.0742Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5113 16.0742H44.6436V22.3242H52.5113V16.0742Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 200H194.288V0H0V200ZM6.23338 193.75V38.3942H188.054V193.75H6.23338ZM188.054 32.1442H96.6509V6.25H188.054V32.1442ZM90.4175 6.25V32.1442H6.23338V6.25H90.4175Z",
    fill: "#528FF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4653 187.5H181.823V44.6445H12.4653V187.5ZM87.2236 158.49C84.8336 148.677 79.8401 140.031 72.6838 133.359C48.382 110.701 65.4284 69.4514 98.85 71.0545C129.566 72.4624 144.795 110.456 122.356 132.639C114.914 139.997 109.713 148.893 107.217 158.49H87.2236ZM86.7149 164.75H107.576V169.996C107.576 175.754 102.901 180.442 97.1577 180.442C91.3991 180.442 86.7149 175.754 86.7149 169.996V164.75ZM18.6987 50.8945H175.589V181.25H109.376C112.103 178.276 113.809 174.345 113.809 169.996V158.49H113.699C116.056 150.583 120.506 143.247 126.733 137.088C153.023 111.098 135.232 66.4644 99.1361 64.8106C60.0951 63.0003 39.831 111.275 68.441 137.937C74.334 143.43 78.5459 150.482 80.7727 158.49H80.4816V169.996C80.4816 174.345 82.1904 178.276 84.9215 181.25H18.6987V50.8945Z",
    fill: "#4F4F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1007 16.0742H64.2329V22.3242H72.1007V16.0742Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.653 16.0742H109.052V22.3242H175.653V16.0742Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.853 81.4367L82.7397 133.436L88.432 135.979L111.545 83.9804L105.853 81.4367Z",
    fill: "#528FF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6845 105.54L84.2537 95.9483L79.8465 91.5293L65.8701 105.54L79.8465 119.551L84.2537 115.132L74.6845 105.54Z",
    fill: "#FF2929"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.441 91.5293L110.034 95.9483L119.603 105.54L110.034 115.132L114.441 119.551L128.418 105.54L114.441 91.5293Z",
    fill: "#F58120"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4329 124.252H27.9282V130.502H41.4329V124.252Z",
    fill: "#7BC658"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M166.359 124.252H141.018V130.502H166.359V124.252Z",
    fill: "#7BC658"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.362 155.504H152.857V161.754H166.362V155.504Z",
    fill: "#7BC658"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7829 155.504H27.9282V161.754H50.7829V155.504Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M166.361 139.879H143.506V146.129H166.361V139.879Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8996 139.879H27.9282V146.129H53.8996V139.879Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageScore);
export default __webpack_public_path__ + "static/media/landingPageScore.318df97e4ea3122a40b0e1cbf0913686.svg";
export { ForwardRef as ReactComponent };